"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAGE_PART_ELEMENTS_MAP_KEY = exports.PAGE_PART_BLOCKS_MAP_KEY = exports.PAGE_DOCUMENT_PART_ID = void 0;
exports.pageStructureMap = pageStructureMap;
exports.pagePartBlocksMap = pagePartBlocksMap;
exports.pagePartElementsMap = pagePartElementsMap;
exports.readPageFormatVersion = readPageFormatVersion;
exports.setPageFormatVersion = setPageFormatVersion;
const page_structure_entry_1 = require("./page-structure-entry");
/**
 * Part 0 is the page document itself: it holds the structure map and the
 * blocks and elements maps of every block and canvas element not in a part
 * document of its own. Further parts of large pages are bound part documents.
 */
exports.PAGE_DOCUMENT_PART_ID = '00000';
/** Map of a page part that holds the fields of its blocks, as in BlockSuite. */
exports.PAGE_PART_BLOCKS_MAP_KEY = 'blocks';
/** Map of a page part that holds the fields of its canvas elements. */
exports.PAGE_PART_ELEMENTS_MAP_KEY = 'elements';
/** Structure map of a page document. */
function pageStructureMap(doc) {
    return doc.getMap(page_structure_entry_1.PAGE_STRUCTURE_MAP_KEY);
}
/** Blocks map of a page part document. */
function pagePartBlocksMap(doc) {
    return doc.getMap(exports.PAGE_PART_BLOCKS_MAP_KEY);
}
/** Elements map of a page part document. */
function pagePartElementsMap(doc) {
    return doc.getMap(exports.PAGE_PART_ELEMENTS_MAP_KEY);
}
/** Map of the page document that holds its format version. */
const PAGE_META_MAP_KEY = 'meta';
const PAGE_FORMAT_KEY = 'pageFormat';
/** Format version of a page document; a page without one is version 1. */
function readPageFormatVersion(doc) {
    const version = doc.getMap(PAGE_META_MAP_KEY).get(PAGE_FORMAT_KEY);
    return typeof version === 'number' ? version : 1;
}
/** Writes the version completed by an upgrade step or current writer. */
function setPageFormatVersion(doc, version) {
    const meta = doc.getMap(PAGE_META_MAP_KEY);
    if (meta.get(PAGE_FORMAT_KEY) !== version)
        meta.set(PAGE_FORMAT_KEY, version);
}
